import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(isSameOrAfter)

export const isObjectEmpty = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}

export const isDateGreaterThanToday = (dateString: string) => {
  try {
    if (!dateString) return false

    const givenDate = dayjs(dateString)

    const today = dayjs().startOf('day')
    return givenDate?.isSameOrAfter(today)
  } catch (err) {
    return false
  }
}
